import {useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import {
  updateSelectedProperty,
  resetSelectedProperty,
} from '@stencil/hotels-common-reducer/src/actions';

import {
  commonSelectorFn,
  pokusMaxChildAgeSelectorFn,
} from '@stencil/hotels-common-reducer/src/selectors';
import {UPDATE_QUERY, IUpdate_Query} from '@stencil/hotels-common-reducer/src/types';
import autosuggestOnSelectionhandler from '../utils/autosuggestOnSelectionHandler';

export default function useSearchWidget() {
  const dispatch = useDispatch();

  const maxChildAge = useSelector(pokusMaxChildAgeSelectorFn);
  const {
    checkin,
    checkout,
    roomString,
    destination,
    country,
    partner,
    selectedHotel,
    isDatePickRequired,
    isRedirectTOSRPRequired,
  } = useSelector(commonSelectorFn);

  const updateQueryCaller = useCallback(
    (actionData: IUpdate_Query['actionData']) => {
      return dispatch({type: UPDATE_QUERY, actionData});
    },
    [dispatch],
  );

  const updatePropertyDetails = useCallback(
    ({propertyId = '', propertyName = '', mmtId = '', resetFlag = false}) => {
      if (resetFlag) {
        dispatch(resetSelectedProperty());
      } else {
        dispatch(
          updateSelectedProperty({
            payload: {
              propertyId,
              propertyName,
              mmtId,
            },
          }),
        );
      }
    },
    [dispatch],
  );
  // ! might be required if there is explicit product ask to update stuff without user clicking UpdateSearch
  // const updateFilterCaller = useCallback(
  //   (actionData: IUpdate_Filter['actionData']) => {
  //     return dispatch({type: UPDATE_FILTER, actionData});
  //   },
  //   [dispatch],
  // );

  const autosuggestHandler = changes => {
    autosuggestOnSelectionhandler(changes, updateQueryCaller, updatePropertyDetails, dispatch);
  };

  return {
    isRedirectTOSRPRequired,
    isDatePickRequired,
    checkin,
    checkout,
    roomString,
    country,
    partner,
    destination,
    selectedHotel,
    maxChildAge,
    autosuggestHandler,
    updateQueryCaller,
  };
}
